import { useTranslation } from 'react-i18next';
import FAQSection from '@/components/base/FAQSection';
import { faqItems } from '@/mocks/faq';

export default function HomeFAQ() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('section.faq')}
          </h2>
        </div>

        <FAQSection items={faqItems} />
      </div>
    </section>
  );
}